import { useState } from 'react'

const useTabsProfile = (initialTabId = null) => {
	const tabs = [
		{
			id: 'digital_profile',
			label: 'Digital Profile',
		},
		{
			id: 'careers',
			label: 'Careers',
		},
		{
			id: 'wishlist',
			label: 'Wishlist',
		},
		{
			id: 'applications',
			label: 'Applications',
		},
		{
			id: 'doc_vault',
			label: 'Doc Vault',
		},
		{
			id: 'recommendations',
			label: 'Recommendations',
		},
		{
			id: 'notes',
			label: 'Notes',
		},
	]

	const isValidInitial =
		initialTabId && tabs.some(tab => tab.id === initialTabId)
	const [activeTabId, setActiveTabId] = useState(
		isValidInitial ? initialTabId : tabs[0].id,
	)

	return {
		tabs,
		activeTabId,
		setActiveTabId,
	}
}

export default useTabsProfile
